import { render, staticRenderFns } from "./DistributionStatus.vue?vue&type=template&id=5bc2ac08&"
import script from "./DistributionStatus.vue?vue&type=script&lang=js&"
export * from "./DistributionStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports